export default __webpack_public_path__ + "static/media/PPF.50aaa90b.jpg";